var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1670 5113 c-266 -44 -503 -288 -543 -559 l-11 -71 -135 -6 c-75 -4 -161 -13 -191 -21 -222 -61 -406 -260 -455 -492 -12 -59 -15 -315 -15 -1720 0 -981 4 -1671 9 -1700 44 -231 230 -440 458 -516 l68 -23 1305 0 1305 0 68 23 c239 80 424 297 460 538 l11 72 135 5 c103 4 151 10 199 26 225 77 409 287 453 515 5 28 9 587 9 1350 l0 1302 -558 640 -558 639 -994 1 c-547 1 -1006 -1 -1020 -3z m1692 -690 c3 -358 5 -381 26 -443 32 -98 89 -187 167 -265 80 -80 151 -125 257 -163 72 -26 78 -27 371 -30 l297 -4 -2 -1156 -3 -1157 -28 -53 c-37 -70 -97 -128 -166 -161 l-56 -26 -1265 0 -1265 0 -56 26 c-69 33 -129 91 -166 161 l-28 53 0 1675 0 1675 24 45 c52 98 109 149 204 181 48 17 109 18 869 19 l817 0 3 -377z m745 -138 l369 -440 -254 -3 c-223 -2 -258 0 -290 15 -90 42 -194 198 -232 349 -17 67 -20 111 -20 333 l1 256 28 -35 c16 -19 195 -233 398 -475z m-2987 -1589 c0 -864 4 -1483 9 -1512 43 -228 223 -433 453 -516 l63 -23 1018 -3 1019 -3 -7 -42 c-17 -100 -95 -199 -194 -246 l-56 -26 -1265 0 -1265 0 -56 26 c-72 34 -134 96 -168 168 l-26 56 0 1670 0 1670 22 47 c11 25 40 67 63 92 71 77 146 102 313 105 l77 1 0 -1464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2187 2866 c-49 -18 -64 -32 -89 -80 -37 -73 -13 -153 62 -203 l33 -23 767 0 767 0 33 23 c50 33 72 70 77 124 5 59 -25 117 -77 147 -34 21 -48 21 -785 23 -610 2 -757 0 -788 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2170 2058 c-111 -56 -119 -196 -16 -272 27 -21 35 -21 806 -21 771 0 779 0 806 21 45 33 67 70 71 121 5 65 -26 120 -87 151 l-44 22 -746 0 -746 0 -44 -22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f9c94a9d3571574e29ebbcda4a7bb6c9.svg";
export { ForwardRef as ReactComponent };